import React from "react"
import ReactDOM from "react-dom"
import moment from "moment"
import { H4 } from "@infotech/uikit-text"
import styles from "./styles.css"

const formatDateInterval = (start, end) => {
  if (!start || !end) {
    return ``
  }

  const mStart = moment(start)
  // the purpose of -1 is when the plan start at 00:00
  // of one day and ends at 00:00 of the next day
  // the `isTheSameDay` check return true
  const mEnd = moment(end - 1)
  const isTheSameDay = mStart.date() === mEnd.date()
  const isTheSameMonth = mStart.month() === mEnd.month()
  const isTheSameYear = mStart.year() === mEnd.year()
  if (isTheSameDay && isTheSameMonth && isTheSameYear) {
    return mStart.format(`D MMMM`)
  }
  if (isTheSameMonth && isTheSameYear) {
    return `${mStart.date()} — ${mEnd.format(`D MMMM`)}`
  }
  if (isTheSameYear) {
    return `${mStart.format(`D MMMM`)} — ${mEnd.format(`D MMMM YYYY`)}`
  }
  return `${mStart.format(`D MMMM YYYY`)} — ${mEnd.format(`D MMMM YYYY`)}`
}

export default class PlanInfo extends React.Component {
  el = document.createElement(`span`)

  render() {
    const { startDateTime, endDateTime, name } = this.props

    return ReactDOM.createPortal(
      <>
        <H4 className={styles[`plan-dates`]}>
          {formatDateInterval(startDateTime, endDateTime)}
        </H4>
        {name && (
          <H4 className={styles[`plan-title`]}>
            <span title={name}>{name}</span>
          </H4>
        )}
      </>,
      this.el,
    )
  }
}
